import type { AppRedirect, AppRedirectContext } from 'src/shared/routes';

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const buildPetitionDetailsUrl = ({ params: { slug }, queryString }: AppRedirectContext) => `/p/${slug!}${queryString}`;

export const REDIRECTS: readonly AppRedirect[] = [
	// Old url used for caching - should not be used anymore
	{
		path: '/pc/:slug',
		buildUrl: buildPetitionDetailsUrl,
		reason: 'deprecated-url',
	},
	// Old signer dashboard
	{
		path: '/p/:slug/f',
		buildUrl: buildPetitionDetailsUrl,
		reason: 'deprecated-url',
	},
	{
		path: '/su/p/:slug/f',
		buildUrl: buildPetitionDetailsUrl,
		reason: 'deprecated-url',
	},

	// Deprecated bot share routes - no longer produced by share link code, but may exist in the wild.
	{
		path: '/p/:slug/fbgst/:sharerDisplayName/:sharerLocation',
		buildUrl: buildPetitionDetailsUrl,
		reason: 'deprecated-url',
	},
	{
		path: '/p/:slug/expg/:shareType/:experimentName/:experimentVariantName/:sharerDisplayName/:sharerLocation',
		buildUrl: buildPetitionDetailsUrl,
		reason: 'deprecated-url',
	},
	{
		path: '/p/:slug/expgst/:experimentName/:experimentVariantName/:sharerDisplayName/:sharerLocation',
		buildUrl: buildPetitionDetailsUrl,
		reason: 'deprecated-url',
	},
];
